import type { MouseEvent, ReactNode } from "react";
import { cn } from "@/shared/lib/cn";
import { entityRefShouldOpenFullPage } from "@/shared/ui/patterns/entityRefBehavior";

export type EntityRefProps = {
  label: ReactNode;
  /** Detail (or filtered list) URL — used for ctrl/meta/middle and as progressive enhance. */
  fullPageTo: string;
  onPeek: () => void;
  className?: string;
  /** Default true — mono for document codes. */
  mono?: boolean;
  title?: string;
};

/**
 * Glance ref on a detail host: click → peek; modified click → full page (D-DT10).
 */
export function EntityRef({
  label,
  fullPageTo,
  onPeek,
  className,
  mono = true,
  title,
}: EntityRefProps) {
  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (entityRefShouldOpenFullPage(e)) return;
    e.preventDefault();
    e.stopPropagation();
    onPeek();
  };

  return (
    <a
      href={fullPageTo}
      title={title}
      className={cn(
        "font-semibold no-underline hover:underline cursor-pointer",
        mono && "font-mono tabular-nums",
        className,
        "text-primary hover:text-primary-hover",
      )}
      onClick={onClick}
    >
      {label}
    </a>
  );
}
